import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError, timer } from 'rxjs';
import { catchError, delayWhen, retryWhen, switchMap, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SessionService {
  private isRenewing = false; // This flag ensures that we don't trigger multiple renewals at once
  private lastCheckTime = 0;
  private readonly minInterval = 30000; // 30s

  private readonly sessionCheckUrl = '/api/session/check';

  constructor(private http: HttpClient) {}

  /**
   * Renews the session by making a keep-alive request.
   * Prevents multiple concurrent requests using the `isRenewing` flag.
   */
  renewSession(): Observable<any> {
    const now = Date.now();

    console.log('[Session] Checking session status...', new Date().toISOString());
    if (this.isRenewing || now - this.lastCheckTime < this.minInterval) {
      return of(null); // skip if already renewing or too soon
    }

    this.isRenewing = true;
    this.lastCheckTime = now;

    const url = `${this.sessionCheckUrl}`; // Use the class property for URL

    return this.http
      .get(url, {
        observe: 'response',
        headers: new HttpHeaders({
          Accept: 'application/json',
          // 'Authorization': 'Bearer xyz', // if needed
        }),
      })
      .pipe(
        tap(() => {
          console.log('[Session] Keep-alive successful', new Date().toISOString());
          this.isRenewing = false;
        }),
        catchError((err) => {
          console.warn('[Session] Keep-alive failed', err, new Date().toISOString());
          this.isRenewing = false;
          // return of(err);
          return throwError(() => err);
          // throw err;
          // return of(null);
        }),
      );
  }

  /**
   * Ensures that a session renewal request happens periodically, even if the user
   * doesn't trigger a request directly. Uses a timer to periodically invoke `renewSession`.
   * @param intervalMs The interval (in milliseconds) between each session renewal request.
   */
  startSessionKeepAlive(intervalMs: number = 30000): Observable<any> {
    return timer(0, intervalMs).pipe(
      switchMap(() => this.renewSession()),
      retryWhen((errors) =>
        errors.pipe(
          delayWhen(() => timer(10000)), // Delay between retries for failed session renewal
        ),
      ),
      catchError((err) => {
        console.error('[Session] Keep-alive failed after multiple attempts', err);
        return of(null);
      }),
    );
  }
}
